import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-qr-codes',
    templateUrl: './walkthrough-qr-codes.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughQrCodesComponent
{
}
